import HistoryIcon from '@atlaskit/icon-lab/core/history';
import * as React from 'react';

export function SvgVersionControl() {
  return <HistoryIcon label="" testId="ads-refreshed-icon" />;
}
